import { render, staticRenderFns } from "./receiptDescriptionEdit.vue?vue&type=template&id=384e578b&"
import script from "./receiptDescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./receiptDescriptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports